// @flow
import React, { Component } from 'react';
import type { ComponentType, Element } from 'react';

// internal utility functions
import { createEmptyContext, withTheme } from './HOC/withTheme';
import { composeTheme, addThemeId, didThemePropsChange } from '../utils/themes';

// import constants
import { IDENTIFIERS } from '.';
import type { ThemeContextProp } from './HOC/withTheme';

type Props = {
  contentLabel: string | Element<any>,
  context: ThemeContextProp,
  isOpen: boolean,
  onClose?: Function,
  skin?: ComponentType<any>,
  triggerCloseOnOverlayClick: boolean,
  theme: ?Object, // will take precedence over theme in context if passed
  themeId: string,
  themeOverrides: Object
};

type State = {
  composedTheme: Object
};

class ModalBase extends Component<Props, State> {
  // define static properties
  static displayName = 'Modal';
  static defaultProps = {
    contentLabel: 'Modal Dialog',
    context: createEmptyContext(),
    isOpen: false,
    triggerCloseOnOverlayClick: true,
    theme: null,
    themeId: IDENTIFIERS.MODAL,
    themeOverrides: {}
  };

  constructor(props: Props) {
    super(props);

    const { context, themeId, theme, themeOverrides } = props;

    this.state = {
      composedTheme: composeTheme(
        addThemeId(theme || context.theme, themeId),
        addThemeId(themeOverrides, themeId),
        context.ROOT_THEME_API
      )
    };
  }

  componentDidUpdate(prevProps: Props) {
    if (prevProps !== this.props) {
      didThemePropsChange(prevProps, this.props, this.setState.bind(this));
    }
  }

  render() {
    // destructuring props ensures only the "...rest" get passed down
    const { skin, theme, themeOverrides, context, ...rest } = this.props;

    const ModalSkin = skin || context.skins[IDENTIFIERS.MODAL];

    return <ModalSkin theme={this.state.composedTheme} {...rest} />;
  }
}

export const Modal = withTheme(ModalBase);
